"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DropdownProps: function() {
        return _react.MenuProps;
    },
    DropdownButtonProps: function() {
        return _react.MenuButtonProps;
    },
    DropdownItemProps: function() {
        return _react.MenuItemProps;
    },
    DropdownListProps: function() {
        return _react.MenuListProps;
    },
    DropdownGroupProps: function() {
        return _react.MenuGroupProps;
    },
    DropdownOptionGroupProps: function() {
        return _react.MenuOptionGroupProps;
    },
    DropdownItemOptionProps: function() {
        return _react.MenuItemOptionProps;
    },
    DropdownDividerProps: function() {
        return _react.MenuDividerProps;
    }
});
var _react = require("@chakra-ui/react");
